import React, { useState, useEffect } from 'react';
import { Button, Grid } from '@mui/material';
import DOMPurify from 'dompurify';
import moment from 'moment'
import { FormattedMessage, injectIntl } from 'react-intl';
import RequestManager from '../../utils/RequestManager';
import HTMLReformat from '../../utils/HTMLReformat';
import LoadingModal from '../Commons/LoadingModal';
import { async } from 'regenerator-runtime';
import PromoModalTerm from './PromoModalTerm';
import { set } from 'lodash';


function Promotions(props) {

    const [term, setTerms] = useState("")
    const [image, setImage] = useState([]);
    const [valDate, setValDate] = useState(true);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [origin, setOrigin] = useState('');
    const [destination, setDestination] = useState('');
    const [size, setSize] = useState(12)
    const [passenger, setPassenger] = useState("");
    const [deep, setDeep] = useState(true);
    const [htmlContent, setHtmlContent] = useState("");

    const validDates = (promo) => {

        let start = moment(promo.startPurchaseDate).format();
        let end = moment(promo.endPurchaseDate).format();
        let between = moment().isBetween(start, end, 'day');
        let same = moment().isSameOrAfter(start, 'day');
        let before = moment().isSame(end, 'day');
        if ((same && between) || before) {
            setValDate(true);
        } else {
            setValDate(false)
        }

    }

    useEffect(() => {
        const handleData = async () => {
            let idSplit = props.location.pathname.split("/");
            if (idSplit.length >= 1) {
                let id = idSplit[idSplit.length - 1];
                let request = {
                    serviceName: 'promoDeep',
                    urlParams: {
                        id
                    }
                };
                const promotions = await RequestManager.callAsyncCmsService(request);
                if (!promotions.error) {
                    setTerms(promotions);
                    validDates(promotions);
                    setImage(promotions.promotionOptions);
                    if (promotions.promotionOptions.length == 2) {
                        setSize(6)
                    } else if (promotions.promotionOptions.length > 2) {
                        setSize(4)
                    }

                    console.log(promotions.adultCount, promotions.childCount, promotions.infantCount)
                    console.log(term.adultCount != 0 && term.childCount != 0 && term.infantCount != 0)
                    console.log(term.adultCount != 0 && term.childCount != 0)
                    if (promotions.adultCount != 0 && promotions.childCount != 0 && promotions.infantCount != 0) {
                        setPassenger("paseACI")
                    } else if (promotions.adultCount != 0 && promotions.childCount != 0) {
                        setPassenger("paseAC")
                    } else if (promotions.adultCount != 0) {
                        setPassenger("paseA")
                    }

                    setLoading(false);
                } else {
                    setDeep(false)
                    request = {
                        serviceName: 'promo',
                        urlParams: {
                            id
                        }
                    };
                    RequestManager.callCmsService(request, loadData, (error) => {
                        console.debug(error);
                    });
                    
                }
            }
            else {
                setLoading(false)
                console.error(new Error("Page not found"));
            }
        }

        handleData()
    }, [])

    const loadData = (htmlContent) => {
        console.log("entre aqui")
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        htmlContent = HTMLReformat.reformatHTML(htmlContent);
        setHtmlContent(htmlContent);
        setLoading(false);
    }

    const modalTerm = (env) => {
        let ori = env.target.value.substring(0, 3);
        let des = env.target.value.substring(3, 6);
        console.log(ori, des)
        setShowModal(true);
        setOrigin(ori);
        setDestination(des);
    }

    const closeMod = () => {
        setShowModal(false)
        setOrigin('');
        setDestination('');
    }




    return (
        <React.Fragment>
            <LoadingModal loading={loading} />
            <PromoModalTerm showModal={showModal} onCancel={closeMod} promotions={term} origin={origin} destination={destination} />
            <Grid container className="promotions-page">
                {deep ? <><Grid item xs={12} className='promoimg'>
                    <Grid className='Promimages'>
                        {image.map((item, index) => {
                            return <Grid key={index} className='promoInf' item xs={size}>
                                <img src={item.image} />
                                {valDate ? <Button variant="contained" color="secondary" className='btnProm' value={item.origin + item.destination} onClick={modalTerm}>
                                    <FormattedMessage id="app.promos.btn" />
                                </Button> : <Button variant="contained" color='primary' className='btnProm' disabled><FormattedMessage id="app.promos.invalid" /></Button>}
                            </Grid>;
                        })}
                    </Grid>
                </Grid><Grid item xs={12}>
                        <h3><FormattedMessage id="app.promos.Tipo" /></h3>
                        <Grid className='promType'>
                            <p>
                                <FormattedMessage id="app.promos.startDate" />{term.startPurchaseDate}
                            </p>
                            <p>
                                <FormattedMessage id="app.promos.endDate" />{term.endPurchaseDate}
                            </p>
                            <p>
                                <FormattedMessage id="app.promos.Periodo" />
                                <FormattedMessage id="app.promo.de" />{moment(term.startTravelPeriod).format('ll')}
                                <FormattedMessage id="app.promo.al" />{moment(term.endTravelPeriod).format('ll')}
                            </p>
                            <p>
                                <FormattedMessage id="app.promos.vuelo" />{term.travelType}
                            </p>
                            <p>
                                <FormattedMessage id="app.promos.pass" /> <FormattedMessage id={"app.promo." + passenger} />
                            </p>
                        </Grid>
                    </Grid></> : <Grid item xs={12} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlContent) }} /> }
            </Grid>
        </React.Fragment>
    );

}

export default injectIntl(Promotions)